import * as RechartsPrimitive from "recharts"

const ChartPie = RechartsPrimitive.Pie

export default ChartPie
